/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FinancialListFinancialResponse } from "./FinancialListFinancialResponse";

export type FinancialListFinancialResponseApiRespoonse = {
  data?: FinancialListFinancialResponse;
  status?: FinancialListFinancialResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace FinancialListFinancialResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
